import { render, staticRenderFns } from "./ArtigosContentDialog.vue?vue&type=template&id=b526fbb6&scoped=true&"
import script from "./ArtigosContentDialog.vue?vue&type=script&lang=js&"
export * from "./ArtigosContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosContentDialog.vue?vue&type=style&index=0&id=b526fbb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b526fbb6",
  null
  
)

export default component.exports